import store from '@/store'

export default [
  {
    path: '/admin/dashboard',
    name: 'dashboard',
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '@/pages/Dashboard')
  }
]
